let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("bOb9Z")).then(() => parcelRequire('2rJye'));